import { render, staticRenderFns } from "./AcademicDrilldown.vue?vue&type=template&id=f753f25c&scoped=true"
import script from "./AcademicDrilldown.vue?vue&type=script&lang=js"
export * from "./AcademicDrilldown.vue?vue&type=script&lang=js"
import style0 from "./AcademicDrilldown.vue?vue&type=style&index=0&id=f753f25c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f753f25c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabItem,VTabs})
